import { caDelete, caGet, caPatch, caPost, caPut } from './http'

let destinationsCache = null

const clearDestinationsCache = () => {
  destinationsCache = null
}

export const cartesApi = {
  async list(params = {}) {
    return caGet('/cartes', params)
  },

  async search(params = {}) {
    return caGet('/cartes/search', params)
  },

  async create(payload) {
    clearDestinationsCache()
    return caPost('/cartes', payload)
  },

  async update(id, payload) {
    clearDestinationsCache()
    return caPut(`/cartes/${id}`, payload)
  },

  async patch(id, patch) {
    clearDestinationsCache()
    return caPatch(`/cartes/${id}`, patch)
  },

  async duplicate(id) {
    clearDestinationsCache()
    return caPost(`/cartes/${id}/duplicate`)
  },

  async remove(id) {
    clearDestinationsCache()
    return caDelete(`/cartes/${id}`)
  },

  async bulkPatch(ids, patch) {
    clearDestinationsCache()
    return caPatch('/cartes/bulk', { ids, patch })
  },

  async bulkRemove(ids) {
    clearDestinationsCache()
    return caPost('/cartes/bulk-delete', { ids })
  },
}

let facilitiesCache = null

export const facilityOptions = async () => {
  if (facilitiesCache) return facilitiesCache
  facilitiesCache = await caGet('/facilities')
  return facilitiesCache
}

export const clearFacilityCache = () => {
  facilitiesCache = null
  destinationsCache = null
}

export const destinationOptions = async () => {
  if (destinationsCache) return destinationsCache
  destinationsCache = await caGet('/destinations')
  return destinationsCache
}
